export default {"src":"https://fishbrain.com/_next/static/media/headerWaveTablet.1581620d.svg","height":331,"width":769,"blurWidth":0,"blurHeight":0};